import { data } from '../../svg/Alarm/data';
import { makeIcon } from '../makeIcon';

export const Alarm = makeIcon(data, 'alarm', 'Alarm');

export default Alarm;
